import React from 'react';
import MemoizedTokensList from '@/components/optimized/MemoizedTokensList';

interface TokensListProps {
  onRefresh?: () => Promise<void>;
}


const TokensList: React.FC<TokensListProps> = (props) => {
  return <MemoizedTokensList {...props} />;
};

export default TokensList;